import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-slate-800 bg-[#0B0F17] pt-14 pb-8">
    <div className="vw-container grid gap-10 md:grid-cols-4">
      <div className="md:col-span-1">
        <Logo />
        <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
          Upload. Analyze. Predict. ⚡ VirtualWin turns your virtual football fixture
          screenshots into focused match-outcome selections in seconds.
        </p>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Explore</h4>
        <ul className="space-y-2.5 text-sm text-slate-400">
          <li><Link to="/" className="hover:text-emerald-400">Home</Link></li>
          <li><Link to="/#about" className="hover:text-emerald-400">About</Link></li>
          <li><Link to="/#how" className="hover:text-emerald-400">How It Works</Link></li>
          <li><Link to="/plans" className="hover:text-emerald-400">Plans</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Account</h4>
        <ul className="space-y-2.5 text-sm text-slate-400">
          <li><Link to="/login" className="hover:text-emerald-400">Login</Link></li>
          <li><Link to="/register" className="hover:text-emerald-400">Register</Link></li>
          <li><Link to="/support" className="hover:text-emerald-400">Support</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
        <ul className="space-y-2.5 text-sm text-slate-400">
          <li><span className="hover:text-emerald-400 cursor-default">Terms</span></li>
          <li><span className="hover:text-emerald-400 cursor-default">Privacy Policy</span></li>
        </ul>
      </div>
    </div>
    <div className="vw-container mt-10 pt-6 border-t border-slate-800 text-center text-sm text-slate-500">
      © {new Date().getFullYear()} VirtualWin. All rights reserved.
    </div>
  </footer>
);
